import { createContext, useReducer, useState } from 'react'

/**
 * Like useState
 * @param defaultValue
 * @returns
 */
export function createCtx<A>(defaultValue: A) {
  type UpdateType = React.Dispatch<React.SetStateAction<typeof defaultValue>>
  const defaultUpdate: UpdateType = () => {
    console.error('Missing context provider!')
    return defaultValue
  }
  const ctx = createContext<[A, UpdateType]>([defaultValue, defaultUpdate])
  function Provider(props: React.PropsWithChildren<{ defaultValue?: A }>) {
    return (
      <ctx.Provider
        value={useState(props.defaultValue ?? defaultValue)}
        {...props}
      />
    )
  }
  return [ctx, Provider] as const // alternatively, [typeof ctx, typeof Provider]
}

/**
 * Like useReducer
 * @param defaultValue
 * @returns
 */
export function createCtxReducer<StateType, ActionType>(
  reducer: React.Reducer<StateType, ActionType>,
  initialState: StateType,
) {
  const ctx = createContext<{
    state: StateType
    dispatch: React.Dispatch<ActionType>
  }>({
    state: initialState,
    dispatch: () => {},
  })
  function Provider(
    props: React.PropsWithChildren<{ defaultValue?: StateType }>,
  ) {
    const [state, dispatch] = useReducer(
      reducer,
      props.defaultValue ?? initialState,
    )
    return <ctx.Provider value={{ state, dispatch }} {...props} />
  }
  return [ctx, Provider] as const
}
